import { BooleanToYesNo, navigateTo } from "../../helper";
import queryString from "query-string";
import RouteNames from "../../routes/type";
import { ClaimState } from "./types";

export const formatPhoneNumber = (input: string): string => {
  const numericInput = input.replace(/[^0-9]/g, "");
  if (!numericInput || numericInput?.length !== 10) {
    return null;
  }
  const areaCode = numericInput.slice(0, 3);
  const firstPart = numericInput.slice(3, 6);
  const secondPart = numericInput.slice(6);
  return `(${areaCode}) ${firstPart}-${secondPart}`;
};

export const nextStepRedirect = (extarProps = {}, step = null) => {
  const parsed = queryString.parse(window.location.search);
  step ||= parseInt(parsed.step.toString()) + 1;
  window.scrollTo(0, 0);
  navigateTo(
    `/${RouteNames.CREATE_CLAIM}?${queryString.stringify({
      ...parsed,
      ...extarProps,
      step,
    })}`
  );
};

export const mapApiClaimStepData = (values: any, step: number) => {
  values ||= {};
  switch (step) {
    case 1:
      return {
        first_name: values["first_name"],
        last_name: values["last_name"],
        email: values["Email"],
        phone_number: values["phone_number"],
        address_1: values["address_1"],
        address_2: values["address_2"],
        city: values["city"],
        state: values["state"],
        zip: values["zip"],
        allowSMS: values["allow_sms"],
      };
    case 2:
      return {
        store_of_purchase: values["store_of_purchase"],
        retailer_phone: values["retailer_phone"],
        retailer_address_1: values["retailer_address_1"],
        retailer_address_2: values["retailer_address_2"],
        retailer_city: values["retailer_city"],
        retailer_state: values["retailer_state"],
        retailer_zip: values["retailer_zip"],
        purchase_date: values["purchase_date"],
      };

    case 3:
      return {
        date_of_incident: values["date_of_incident"],
        product_size: values["protector_encasement_size"],
        product_type: values["protector_encasement_type"],
        mattress_stained_damaged: values["mattress_stained_damaged"],
        type_of_stain_damage: values["type_of_stain_damage"],
        protector_encasement_stained_damaged:
          values["protector_encasement_stained_damaged"],
        type_of_stain_damage_protector:
          values["type_of_stain_damage_protector"],
        estimated_mattress_retail_value:
          values["estimated_mattress_retail_value"],
        did_you_clean_the_protector_encasement:
          values["did_you_clean_the_protector_encasement"],
        damageNotes: values["damage_notes"],
        encasement_on_your_bed_at_the_time_of_the_incident:
          values["encasement_on_your_bed_at_the_time_of_the_incident"],
      };
    default:
      return values;
  }
};

export const mapApiClaimData = (payload): ClaimState => {
  return {
    id: payload?.["id"],
    name: payload?.["Name"],
    first_name: payload?.["first_name"],
    last_name: payload?.["last_name"],
    email: payload?.["Email"],
    phone_number: payload?.["phone_number"],
    address_1: payload?.["address_1"],
    address_2: payload?.["address_2"],
    city: payload?.["city"],
    state: payload?.["state"],
    zip: payload?.["zip"],
    allowSMS: payload?.["allow_sms"],
    store_of_purchase: payload?.["store_of_purchase"],
    retailer_phone: payload?.["retailer_phone"],
    retailer_address_1: payload?.["retailer_address_1"],
    retailer_address_2: payload?.["retailer_address_2"],
    retailer_city: payload?.["retailer_city"],
    retailer_state: payload?.["retailer_state"],
    retailer_zip: payload?.["retailer_zip"],
    purchase_date: payload?.["purchase_date"],
    invoice_image: payload?.["invoice_image"],
    date_of_incident: payload?.["date_of_incident"],
    product_size: payload?.["protector_encasement_size"],
    product_type: payload?.["protector_encasement_type"],
    mattress_stained_damaged: payload?.["mattress_stained_damaged"],
    type_of_stain_damage: payload?.["type_of_stain_damage"],
    protector_encasement_stained_damaged:
      payload?.["protector_encasement_stained_damaged"],
    type_of_stain_damage_protector: payload?.["type_of_stain_damage_protector"],
    estimated_mattress_retail_value:
      payload?.["estimated_mattress_retail_value"],
    did_you_clean_the_protector_encasement:
      payload?.["did_you_clean_the_protector_encasement"],
    damageNotes: payload?.["damage_notes"],
    encasement_on_your_bed_at_the_time_of_the_incident:
      payload?.["encasement_on_your_bed_at_the_time_of_the_incident"],
    protector_damage_images: payload["protector_damage_images"]
      ? payload["protector_damage_images"].split("\n\n")
      : [],
    mattress_damage_images: payload["mattress_damage_images"]
      ? payload["mattress_damage_images"].split("\n\n")
      : [],
    protectall_tag_image: payload["protectall_tag_image"],
  };
};

export const makeHTMLContentForTicket = (data, claimName) => {
  data.did_you_clean_the_protector_encasement = BooleanToYesNo(
    data.did_you_clean_the_protector_encasement
  );
  data.encasement_on_your_bed_at_the_time_of_the_incident = BooleanToYesNo(
    data.encasement_on_your_bed_at_the_time_of_the_incident
  );
  data.mattress_stained_damaged = BooleanToYesNo(data.mattress_stained_damaged);
  data.protector_encasement_stained_damaged = BooleanToYesNo(
    data.protector_encasement_stained_damaged
  );
  const labels = {
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email",
    phone_number: "Phone Number",
    address_1: "Address 1",
    address_2: "Address 2",
    city: "City",
    state: "State",
    zip: "Zip Code",
    store_of_purchase: "Store of Purchase",
    retailer_phone: "Retailer Phone",
    retailer_address_1: "Retailer Address 1",
    retailer_address_2: "Retailer Address 2",
    retailer_city: "Retailer City",
    retailer_state: "Retailer State",
    retailer_zip: "Retailer Zip",
    purchase_date: "Purchase Date",
    invoice_image: "Invoice Image",
    date_of_incident: "Date of Incident",
    product_size: "Product Size",
    product_type: "Product Type",
    mattress_stained_damaged: "Mattress Stained/Damaged",
    type_of_stain_damage: "Type of Stain/Damage",
    protector_encasement_stained_damaged:
      "Protector/Encasement Stained/Damaged",
    type_of_stain_damage_protector: "Type of Stain/Damage (Protector)",
    estimated_mattress_retail_value: "Estimated Mattress Retail Value",
    did_you_clean_the_protector_encasement:
      "Did You Clean the Protector/Encasement?",
    encasement_on_your_bed_at_the_time_of_the_incident:
      "Encasement on Bed at Time of Incident?",
    damageNotes: "Damage Notes",
    protector_damage_images: "Protector Damage Images",
    mattress_damage_images: "Mattress Damage Images",
    protectall_tag_image: "ProtectAll Tag Image",
  };

  const getValue = (value) => {
    value ||= "";
    value = value.toString();
    return value.startsWith("https://")
      ? value.toLowerCase().endsWith(".pdf")
        ? `<a href="${value}"><img src="https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg" style="width: 64px; height: 64px; border-radius: 4px; object-fit: contain;margin-right:8px;"></a>`
        : `<a href="${value}"><img src="${value}" style="width: 64px; height: 64px; border-radius: 4px; object-fit: cover;margin-right:8px;"></a>`
      : value || false;
  };

  const renderRow = (key, value) => {
    const fomrattedValue = Array.isArray(value)
      ? value.length > 0
        ? value.map(getValue).join("")
        : false
      : getValue(value);

    if (fomrattedValue)
      return `<tr><td style="font-weight: 500; padding: 4px; width:300px;"><strong>${
        labels[key] || key
      }</strong></td><td style="padding:4px;">${fomrattedValue}</td></tr>`;
  };

  const renderSection = (title, content) =>
    `<div style="background: rgba(243, 248, 254, 0.8); padding: 4px 8px; border: 1px solid #ccc; border-radius: 8px; margin-bottom: 10px;">
      <p style="font-weight: bold; font-size: 18px; color: black; margin-bottom: 10px;">${title}</p>
      <table style="width: 100%; border-collapse: separate; border-spacing: 0 10px; font-size: 14px; color: black;">
        ${content}
      </table>
    </div>`;

  const customerDetails = [
    "first_name",
    "last_name",
    "email",
    "phone_number",
    "address_1",
    "address_2",
    "city",
    "state",
    "zip",
  ]
    .map((key) => renderRow(key, data[key]))
    .join("");

  const purchaseDetails = [
    "store_of_purchase",
    "retailer_phone",
    "retailer_address_1",
    "retailer_address_2",
    "retailer_city",
    "retailer_state",
    "retailer_zip",
    "purchase_date",
    "invoice_image",
  ]
    .map((key) => renderRow(key, data[key]))
    .join("");

  const damageDetails = [
    "date_of_incident",
    "product_size",
    "product_type",
    "mattress_stained_damaged",
    "type_of_stain_damage",
    "protector_encasement_stained_damaged",
    "type_of_stain_damage_protector",
    "estimated_mattress_retail_value",
    "did_you_clean_the_protector_encasement",
    "encasement_on_your_bed_at_the_time_of_the_incident",
    "damageNotes",
    "protector_damage_images",
    "mattress_damage_images",
    "protectall_tag_image",
  ]
    .map((key) => renderRow(key, data[key]))
    .join("");

  return `<div style="font-family: Arial, sans-serif; background-color: #fff;">
    <div style="max-width: 600px; margin: auto;">
    <div style="background: rgba(243, 248, 254, 0.8); padding: 12px; border: 1px solid #ccc; border-radius: 8px; margin-bottom: 5px;">
      <p style="font-weight: bold; font-size: 24px; color: black;text-align:center;margin:0px">${claimName}</p>
    </div>
      ${renderSection("Customer Information", customerDetails)}
      ${renderSection("Purchase Information", purchaseDetails)}
      ${renderSection("Damage Details", damageDetails)}
    </div>
  </div>`;
};
